export function reloadCurrentPage() {
  window.location.reload()
}
